import { adminMutation } from "@/admin/utils/adminMutation.ts";
import type { ApiClient } from "@/modules/api/apiClient.ts";
import { getResponseData } from "@/modules/api/apiClient.ts";
import { jsonEncodedBody } from "@/utils/fetchClient.ts";
import { atomFromStandardQueryOptions } from "@/utils/query/queryAtom.ts";
import { queryOptions, type QueryKey } from "@tanstack/react-query";
import type { GoogleTagManagerKey } from "@warrenio/api-spec/spec.oats.gen";

//#region Query and parameters
const queryKey: QueryKey = ["config/ui/gtm_key"];

function getQuery(client: ApiClient) {
    return queryOptions({
        queryKey,
        queryFn: async ({ signal }): Promise<GoogleTagManagerKey> => {
            return getResponseData(await client.GET("/config/ui/gtm_key", { signal }));
        },
    });
}
//#endregion

//#region Atoms
export const googleTagManagerQueryAtom = atomFromStandardQueryOptions(getQuery);
//#endregion

//#region Mutations

export const googleTagManagerMutation = adminMutation((apiClient) => ({
    entity: "Google Tag Manager key",
    operation: "update",
    requestFn: async (body: GoogleTagManagerKey) =>
        await apiClient.PUT("/config/ui/gtm_key", { ...jsonEncodedBody, body }),
    invalidateQueryKey: queryKey,
}));

//#endregion
